import { ColorOrKey } from "@faire/web/slate/Color";
import { Tooltip } from "@faire/web/slate/Tooltip";
import { Position } from "@faire/web/slate/Tooltip/common";
import { Typography } from "@faire/web/slate/Typography";
import { ParagraphVariants } from "@faire/web/slate/Typography/Types";
import parse, { DOMNode, Element, Text } from "html-react-parser";
import React from "react";

export const TextWithTooltip = ({
  text,
  textColor,
  tooltipText,
  tooltipTypographyVariant,
  tooltipPosition,
  tooltipWidth,
}: {
  text: string;
  textColor?: ColorOrKey;
  tooltipText: string;
  tooltipTypographyVariant?: ParagraphVariants;
  tooltipPosition?: Position;
  tooltipWidth?: number;
}) => {
  const transform = (node: DOMNode) => {
    if (
      node instanceof Element &&
      (node.name === "b" || node.name === "u" || node.name === "span")
    ) {
      const targetText = (node.children[0] as Text).data;
      return (
        <Tooltip
          targetNode={
            <Typography
              textDecoration="dottedUnderline"
              variant={tooltipTypographyVariant}
              color={textColor}
            >
              {targetText}
            </Typography>
          }
          contents={[{ body: tooltipText }]}
          position={tooltipPosition}
          width={tooltipWidth}
        />
      );
    }
    return undefined;
  };
  return (
    <Typography as="span" color={textColor}>
      {parse(text, { replace: transform })}
    </Typography>
  );
};
